
const charactersToBeEscaped = ['/'];
const escapeCharacter = '\\';

const saniticeCssSelector = (string) => {
  let saniticedString = string;
  charactersToBeEscaped.forEach(character => {
    saniticedString = saniticedString.replaceAll(character, `${escapeCharacter}${character}`);
  });
  return saniticedString;
};

export default { saniticeCssSelector };